var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { html } from 'lit-html';
import { property, query, state } from 'lit/decorators.js';
import { cloneDeep, uniqueId } from 'lodash-es';
import { translate } from '../../../utilities/translate';
import { currentDateKey } from '../../../datepicker/date/date-picker-calculations';
import { dateTimeToKey, displayDateTime, getCurrentLocaleDate, keyToDateTime, } from '../../utils/date-time.util';
import styles from './sds-date-time-picker.lit.scss';
import { appendStylesToTheStyleRoot } from '../../../utilities/dom';
import '../../../input/time-picker/sds-time-picker-input.lit';
import '../../../time/components/shared/sds-time-picker-content.lit';
import '../../../datepicker/shared/calendar/sds-calendar.lit';
import '../../../button/default/sds-button.lit';
import { hideMenuProvider } from '../../../utilities/picker.tools';
import { getElementById } from '../../../time/utils/time.util';
import { sdsCustomElement } from '../../../utilities/custom-components';
/**
 * `sds-date-time-picker` is a web component that provides an interactive interface for selecting both
 * dates and times. It combines a date picker and a time picker, offering a seamless experience for users
 * to choose specific moments in time.
 */
let SdsDateTimePicker = (() => {
    var _SdsDateTimePicker_hint_accessor_storage, _SdsDateTimePicker_disabled_accessor_storage, _SdsDateTimePicker_invalid_accessor_storage, _SdsDateTimePicker_errorMessage_accessor_storage, _SdsDateTimePicker_placeholder_accessor_storage, _SdsDateTimePicker_locale_accessor_storage, _SdsDateTimePicker_format_accessor_storage, _SdsDateTimePicker__inputDate_accessor_storage, _SdsDateTimePicker__contextMenu_accessor_storage, _SdsDateTimePicker__tempDateTime_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-date-time-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let _format_decorators;
    let _format_initializers = [];
    let _format_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __tempDateTime_decorators;
    let __tempDateTime_initializers = [];
    let __tempDateTime_extraInitializers = [];
    let _set_value_decorators;
    var SdsDateTimePicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsDateTimePicker_hint_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsDateTimePicker_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsDateTimePicker_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsDateTimePicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsDateTimePicker_placeholder_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _placeholder_initializers, 'sds.date_time_picker.placeholder')));
            _SdsDateTimePicker_locale_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _locale_initializers, navigator.language)));
            _SdsDateTimePicker_format_accessor_storage.set(this, (__runInitializers(this, _locale_extraInitializers), __runInitializers(this, _format_initializers, 24)));
            _SdsDateTimePicker__inputDate_accessor_storage.set(this, (__runInitializers(this, _format_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            _SdsDateTimePicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, __inputDate_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsDateTimePicker__tempDateTime_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __tempDateTime_initializers, undefined)));
            this._dateTime = __runInitializers(this, __tempDateTime_extraInitializers);
            this._inputId = uniqueId('sds-date-time-picker');
            this._calendarId = uniqueId('sds-calendar');
            this._sdsTimePickerContent = uniqueId('sds-time-picker-content');
            this._currentDay = currentDateKey();
            this.hideMenu = (event) => {
                var _a;
                hideMenuProvider(this)(event);
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this._tempDateTime = undefined;
                }
            };
            this.clear = () => {
                this.value = undefined;
                this.dispatch(null);
                this.hideMenu();
            };
            this.handleOK = () => {
                if (this._tempDateTime) {
                    this._dateTime = this._tempDateTime;
                }
                if (!this.value) {
                    return;
                }
                this.dispatch(this.value);
                this.updateInput();
                this.hideMenu();
            };
            this.handleTimeChange = (event) => {
                if (this._tempDateTime) {
                    this._tempDateTime.time = event.detail.value;
                }
            };
            this.handleDatePicked = (event) => {
                if (this._tempDateTime) {
                    this._tempDateTime.date = event.detail.date;
                }
            };
            this.showContextMenu = () => {
                if (this._contextMenu.opened) {
                    return;
                }
                this.prepareContextMenu();
                setTimeout(() => {
                    var _a;
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.show(trigger);
                });
                document.addEventListener('mousedown', this.hideMenu);
            };
        }
        /**
         * Hint for this date time picker.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsDateTimePicker_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsDateTimePicker_hint_accessor_storage, value, "f"); }
        /**
         * True if this date time picker is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsDateTimePicker_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsDateTimePicker_disabled_accessor_storage, value, "f"); }
        /**
         * True if this date time picker is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsDateTimePicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsDateTimePicker_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this date time picker, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsDateTimePicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsDateTimePicker_errorMessage_accessor_storage, value, "f"); }
        /**
         * A placeholder text that appears inside the picker input when no value is selected.
         * It provides a hint to the user about the expected input format or purpose of the picker.
         *
         * @attr {string} placeholder - Placeholder text displayed in the input field.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsDateTimePicker_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsDateTimePicker_placeholder_accessor_storage, value, "f"); }
        /**
         * The locale used for formatting dates and times within the picker.
         * This value determines the display format based on the user’s regional settings,
         * such as `'en-US'` or `'fr-FR'`.
         *
         * Defaults to the browser's current language (`navigator.language`).
         *
         * @attr {string} locale - Locale for date and time formatting.
         */
        get locale() { return __classPrivateFieldGet(this, _SdsDateTimePicker_locale_accessor_storage, "f"); }
        set locale(value) { __classPrivateFieldSet(this, _SdsDateTimePicker_locale_accessor_storage, value, "f"); }
        /**
         * Specifies the time format used by the picker: either 12-hour (AM/PM) or 24-hour format.
         * This helps adapt the picker to different user preferences or regional standards.
         *
         * Defaults to `24`.
         *
         * @attr {number} format - Time format used by the picker (`12` or `24`).
         */
        get format() { return __classPrivateFieldGet(this, _SdsDateTimePicker_format_accessor_storage, "f"); }
        set format(value) { __classPrivateFieldSet(this, _SdsDateTimePicker_format_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsDateTimePicker__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsDateTimePicker__inputDate_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsDateTimePicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsDateTimePicker__contextMenu_accessor_storage, value, "f"); }
        get _tempDateTime() { return __classPrivateFieldGet(this, _SdsDateTimePicker__tempDateTime_accessor_storage, "f"); }
        set _tempDateTime(value) { __classPrivateFieldSet(this, _SdsDateTimePicker__tempDateTime_accessor_storage, value, "f"); }
        get value() {
            return dateTimeToKey(this._dateTime);
        }
        /** {year}/{month}/{day}/{hour}/{minute} format */
        set value(value) {
            this.requestUpdate('value', this.value);
            this._dateTime = keyToDateTime(value);
        }
        get sdsCalendar() {
            var _a;
            if (!this._sdsCalendar) {
                this._sdsCalendar = ((_a = this._contextMenu.queryMenuChild('sds-calendar')) !== null && _a !== void 0 ? _a : getElementById(this._calendarId));
            }
            return this._sdsCalendar;
        }
        async connectedCallback() {
            super.connectedCallback();
            appendStylesToTheStyleRoot(this, 'sds-date-time-picker', styles.cssText);
            await this.updateComplete;
            this.setMappers();
        }
        render() {
            var _a, _b;
            return html `
            <sds-input-date
                id="${this._inputId}"
                placeholder="${translate(this.placeholder)}"
                value="${this.getTimePickerValue()}"
                readonly="${true}"
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.clear}"
            ></sds-input-date>
            <sds-context-menu maxHeight="450px">
                <div class="sds-date-time-picker">
                    <sds-calendar
                        id="${this._calendarId}"
                        currentDay="${this._currentDay}"
                        tabindex="0"
                        locale="${this.locale}"
                        @sds.calendar.select="${this.handleDatePicked}"
                    >
                    </sds-calendar>
                    <div class="sds-time-picker-wrapper">
                        <sds-icon name="time" size="24"></sds-icon>
                        <sds-time-picker-content
                            id="${this._sdsTimePickerContent}"
                            hour="${(_a = this._tempDateTime) === null || _a === void 0 ? void 0 : _a.time.hour}"
                            minute="${(_b = this._tempDateTime) === null || _b === void 0 ? void 0 : _b.time.minute}"
                            format="${this.format}"
                            @sds.date-time-content.changed="${this.handleTimeChange}"
                        ></sds-time-picker-content>
                    </div>

                    <div class="sds-date-time-picker__footer">
                        <sds-button
                            label="${translate('sds.button.ok')}"
                            type="primary"
                            size="sm"
                            @click="${this.handleOK}"
                        ></sds-button>
                    </div>
                </div>
            </sds-context-menu>
        `;
        }
        disconnectedCallback() {
            document.removeEventListener('mousedown', this.hideMenu);
            this.hideMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        willUpdate(_changedProperties) {
            super.willUpdate(_changedProperties);
            if (_changedProperties.has('value')) {
                this.hideMenu();
            }
        }
        prepareContextMenu() {
            if (!this._dateTime) {
                this.value = undefined;
            }
            this._tempDateTime = cloneDeep(this._dateTime);
            this._tempDateTime.date = this._tempDateTime.date || getCurrentLocaleDate();
            this.updatePageIndex();
            this.setMappers();
        }
        updatePageIndex() {
            var _a;
            if (this._tempDateTime && this._tempDateTime.date) {
                (_a = this.sdsCalendar) === null || _a === void 0 ? void 0 : _a.setPageIndex(this._tempDateTime.date[0], this._tempDateTime.date[1]);
            }
        }
        setMappers() {
            if (!this.sdsCalendar) {
                return;
            }
            this.sdsCalendar.setDateStateMapper(([keyYear, keyMonth, keyDay]) => {
                return this._tempDateTime &&
                    this._tempDateTime.date &&
                    keyYear === this._tempDateTime.date[0] &&
                    keyMonth === this._tempDateTime.date[1] &&
                    keyDay === this._tempDateTime.date[2]
                    ? 'selected'
                    : 'none';
            });
            this.sdsCalendar.setMonthStateMapper(([keyYear, keyMonth]) => this._tempDateTime &&
                this._tempDateTime.date &&
                keyYear === this._tempDateTime.date[0] &&
                keyMonth === this._tempDateTime.date[1]
                ? 'selected'
                : 'none');
            this.sdsCalendar.setYearStateMapper(keyYear => this._tempDateTime && this._tempDateTime.date && keyYear === this._tempDateTime.date[0]
                ? 'selected'
                : 'none');
        }
        updateInput() {
            this._inputDate.value = this.getTimePickerValue();
        }
        dispatch(value) {
            this.dispatchEvent(new CustomEvent(SdsDateTimePicker.CHANGE_EVENT, {
                detail: { value },
                bubbles: false,
                composed: false,
            }));
        }
        getTimePickerValue() {
            if (this.value) {
                return `${displayDateTime(this.value, this.locale, this.format === 12)}`;
            }
            return '';
        }
    };
    _SdsDateTimePicker_hint_accessor_storage = new WeakMap();
    _SdsDateTimePicker_disabled_accessor_storage = new WeakMap();
    _SdsDateTimePicker_invalid_accessor_storage = new WeakMap();
    _SdsDateTimePicker_errorMessage_accessor_storage = new WeakMap();
    _SdsDateTimePicker_placeholder_accessor_storage = new WeakMap();
    _SdsDateTimePicker_locale_accessor_storage = new WeakMap();
    _SdsDateTimePicker_format_accessor_storage = new WeakMap();
    _SdsDateTimePicker__inputDate_accessor_storage = new WeakMap();
    _SdsDateTimePicker__contextMenu_accessor_storage = new WeakMap();
    _SdsDateTimePicker__tempDateTime_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsDateTimePicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _placeholder_decorators = [property({ type: String })];
        _locale_decorators = [property({ type: String })];
        _format_decorators = [property({ type: Number })];
        __inputDate_decorators = [query('sds-input-date')];
        __contextMenu_decorators = [query('sds-context-menu')];
        __tempDateTime_decorators = [state()];
        _set_value_decorators = [property({ type: String, reflect: true })];
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _locale_decorators, { kind: "accessor", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, get: obj => obj.locale, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, _locale_initializers, _locale_extraInitializers);
        __esDecorate(_classThis, null, _format_decorators, { kind: "accessor", name: "format", static: false, private: false, access: { has: obj => "format" in obj, get: obj => obj.format, set: (obj, value) => { obj.format = value; } }, metadata: _metadata }, _format_initializers, _format_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __tempDateTime_decorators, { kind: "accessor", name: "_tempDateTime", static: false, private: false, access: { has: obj => "_tempDateTime" in obj, get: obj => obj._tempDateTime, set: (obj, value) => { obj._tempDateTime = value; } }, metadata: _metadata }, __tempDateTime_initializers, __tempDateTime_extraInitializers);
        __esDecorate(_classThis, null, _set_value_decorators, { kind: "setter", name: "value", static: false, private: false, access: { has: obj => "value" in obj, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsDateTimePicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGE_EVENT = 'sds.date-time-picker.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsDateTimePicker = _classThis;
})();
export { SdsDateTimePicker };
